
import { Component, OnInit } from '@angular/core';
import { CandidatesService, AuthService } from '../../services';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class loginComponent implements OnInit {
  focus: any;
  focus1: any;
  isResetPassword = false;
  user = { email: null, password: null };
  isLoading = false;
  wrongCredentials = false;
  wrongEmail = false;
  constructor(private toastr: ToastrService, private route: ActivatedRoute, private router: Router, private apiService: CandidatesService, private authService: AuthService) {

  }
  ngOnInit() {

  }

  login() {
    var myParam;
    var sub = this.route.params.subscribe((params: Params) => myParam = params);
    // var f = this._location.back();
    // console.warn(this._location.back());
    // console.warn(this._location.path());
    this.isLoading = true;
    this.apiService.login(this.user).subscribe((res: any) => {
      this.isLoading = false;
      this.authService.user = res.data;
      this.authService.updateMe();

      if (res.data.email_verified_at == null || myParam.queryParams == 'user-profile')
        this.router.navigate(['/user-profile']);
      else
        this.router.navigate(['/']);
    },
      (error) => {
        this.isLoading = false;
        if (error?.error?.message == "Wrong Credentials")
          this.wrongCredentials = true;
        this.toastr.error(error?.error?.message, "Login");
      });
  }

  canSubmit() {
    return this.user.email && this.user.password;
  }

  resetPassword() {
    this.isResetPassword = true;
  }

  reset() {
    this.isLoading = true;
    this.apiService.resetPassword(this.user).subscribe((res: any) => {
      this.isLoading = false;
      this.wrongEmail = false;
      this.toastr.success(res.message, "Login");
    },
      (error) => {
        this.isLoading = false;
        if (error?.error?.message == "Wrong Email")
          this.wrongEmail = true;
        this.toastr.error(error?.error?.message, "Reset Password");
      });
  }

  signUp() {
    this.router.navigate(['/signup']);
  }

  signIn() {
    this.isResetPassword = false;
  }
}
